import { memo } from "react";
import { Button, Tooltip, Badge } from "antd";
import { MdOutlineMessage, MdSearch } from "react-icons/md";
import { UI_HeaderStyles } from "../HeaderStyles";
import { showCommentPanelAtom, showSearchAddressPanelAtom, showSharePanelAtom } from '~/components/Map/stores/mapStore';
import { useAtom } from 'jotai';

const HeaderRight = () => {
  const [showSearchAddressPanel, setShowSearchAddressPanel] = useAtom<boolean>(showSearchAddressPanelAtom);
  const [showCommentPanel, setShowCommentPanel] = useAtom<boolean>(showCommentPanelAtom);
  const [showSharePanel, setShowSharePanel] = useAtom<boolean>(showSharePanelAtom);

  const clearAllActiveState = () => {
    setShowSearchAddressPanel(false);
    setShowCommentPanel(false);
    setShowSharePanel(false);
  }

  return (<>
    {/* Tìm kiếm */}
    <UI_HeaderStyles.UI_Item
      style={{
        backgroundColor: showSearchAddressPanel ? 'var(--color-primary)' : 'white',
      }
      }
      onClick={() => {
        const newState = !showSearchAddressPanel;
        clearAllActiveState();
        setShowSearchAddressPanel(newState);
      }}>
      <Tooltip title='Tìm kiếm'>
        <Button type='text' style={{ padding: 8 }}>
          <MdSearch size={18} style={{
            color: showSearchAddressPanel ? 'white' : 'black',
          }} />
        </Button>
      </Tooltip>
    </UI_HeaderStyles.UI_Item >
    {/* End Tìm kiếm */}
    {/* Ghi chú */}
    <UI_HeaderStyles.UI_Item
      style={{
        backgroundColor: showCommentPanel ? 'var(--color-primary)' : 'white',
      }}
      onClick={() => {
        const newState = !showCommentPanel;
        clearAllActiveState();
        setShowCommentPanel(newState);
      }}>
      <Tooltip title='Ghi chú'>
        {/* <Badge count={5} size="small"> */}
        <Button type='text' style={{ padding: '0px 8px' }}>
          <MdOutlineMessage size={18} style={{
            color: showCommentPanel ? 'white' : 'black',
          }} />
        </Button>
        {/* </Badge> */}
      </Tooltip>
    </UI_HeaderStyles.UI_Item>
    {/* End Ghi Chú */}
  </>);
};
export default memo(HeaderRight);